/* post-t7-1, Bloque E1 (#601): DESPUES DE INICIAR SESION, LA PERSONA LLEGA A DONDE IBA.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Quien abre una liga del producto sin sesion (el boton del reporte del domingo, la liga de un recordatorio) es mandado
   a entrar por el guardia de ruta. Antes de mandarlo, el guardia GUARDA la ruta a la que iba (camino mas consulta) en
   el almacenamiento de la sesion del navegador (sobrevive la ida y vuelta a Google o a Apple en la misma pestana).
   Al terminar de entrar por CUALQUIER puerta, `destinoDespuesDeEntrar()` da esa ruta si es valida (si no, el Panel,
   como antes). La ruta se usa UNA vez: el guardia la borra en cuanto pinta una ruta con sesion para alguien con
   sesion, y cerrar sesion tambien la borra.

   VALIDA, todo a la vez: empieza con UNA sola diagonal; es una ruta que el router declara y que pide sesion; no es de
   entrar, crear cuenta ni recuperar contrasena; mide menos de 300 caracteres. Cualquier otra cosa se descarta en
   silencio. Nunca se navega a otro dominio ni a algo que venga de la consulta de la URL: solo a lo que el guardia
   guardo (la consulta se conserva como parte de la ruta, pero el camino tiene que ser uno de los del router). */

export const LLAVE_RUTA_PENDIENTE = 'sb_ruta_pendiente';
/** post-t7-1 N (revisor de puertas): la ruta en la que estaba quien CERRO sesion (ver `marcarSalida`). */
export const LLAVE_RUTA_AL_SALIR = 'sb_ruta_al_salir';
export const LARGO_MAXIMO = 300;
/** post-t7-2b (D7 a): la pestana tuvo una sesion. Vale "1" y nada mas: ningun dato de la persona. */
export const LLAVE_HUBO_SESION = 'sb_hubo_sesion';

/** Las rutas con sesion que declara el router (App.js); una prueba compara esta lista con la tabla de App.js. */
export const RUTAS_CON_SESION = [
  '/dashboard', '/pending', '/study', '/study/exam', '/study/flashcards', '/study/adaptive', '/study/log',
  '/analytics', '/upgrade', '/earn-credits', '/tutor', '/admin/errors', '/admin/dashboard', '/settings', '/manage-documents', '/groups',
  '/groups/:groupId', '/groups/:groupId/avance', '/groups/:groupId/bank/:docId',
  '/groups/:groupId/bank/:docId/temas/:temaId', '/support', '/diag/ready-chain',
  // estilos-1 (#780): la pagina "Ver como se ve" del correo de formulas (solo admin): tras entrar, vuelve a ella.
  '/sb-ctrl/formulas/:docId',
];

const NUNCA = ['/login', '/signup', '/forgot-password', '/reset-password', '/verify-email', '/auth/'];

const PATRONES = RUTAS_CON_SESION.map((r) => new RegExp('^' + r.replace(/:[A-Za-z]+/g, '[A-Za-z0-9_-]+') + '$'));

/** La ruta, si es valida (camino mas consulta); si no, null. */
export function rutaValida(ruta) {
  if (typeof ruta !== 'string' || !ruta || ruta.length >= LARGO_MAXIMO) return null;
  if (ruta[0] !== '/' || ruta[1] === '/' || ruta.includes('\\') || /[\s\u0000-\u001f]/.test(ruta)) return null;
  const corte = ruta.search(/[?#]/);
  const camino = corte === -1 ? ruta : ruta.slice(0, corte);
  if (NUNCA.some((n) => camino === n || camino.startsWith(n.endsWith('/') ? n : `${n}/`))) return null;
  return PATRONES.some((p) => p.test(camino)) ? ruta : null;
}

function almacen() {
  try { return window.sessionStorage; } catch { return null; }
}

/** post-t7-2b (D7 a): los guardias lo llaman cuando pintan con sesion. Si despues un guardia pinta SIN sesion y sin que
    nadie haya cerrado sesion (`marcarSalida` borra la marca), la sesion VENCIO: en una pestana o un telefono compartido
    la siguiente persona caeria en la ruta de la anterior. Decision: la ruta de una sesion vencida NO se guarda (se trata
    como un cierre de sesion). */
export function notarSesion() {
  const s = almacen();
  if (!s) return;
  try { s.setItem(LLAVE_HUBO_SESION, '1'); } catch { /* sin almacenamiento: lo de antes */ }
}

/** El guardia: guarda la ruta a la que iba (solo si es valida y no es la que dejo quien cerro sesion, o la de una
    sesion que vencio). */
export function guardarRutaPendiente(ruta) {
  const r = rutaValida(ruta);
  const s = almacen();
  if (!s) return;
  try {
    // post-t7-2b (D7 a): la primera ruta sin sesion despues de una sesion que no se cerro es la de la sesion que vencio:
    // queda marcada como la de un cierre (no se guarda) y la pestana vuelve a estar limpia para otra liga
    if (s.getItem(LLAVE_HUBO_SESION)) {
      s.removeItem(LLAVE_HUBO_SESION);
      s.removeItem(LLAVE_RUTA_PENDIENTE);
      if (r) s.setItem(LLAVE_RUTA_AL_SALIR, r);
      return;
    }
    if (!r) return;
    if (s.getItem(LLAVE_RUTA_AL_SALIR) === r) return;
    s.setItem(LLAVE_RUTA_PENDIENTE, r);
  } catch { /* sin almacenamiento: lo de antes */ }
}

/** post-t7-1 N (revisor de puertas): cerrar sesion marca la ruta en la que estaba. En la app nadie navega al cerrar
    sesion: el guardia pinta esa MISMA ruta con el usuario ya en null y la habria guardado para la siguiente persona
    que entre en el telefono. Con la marca, esa ruta no se guarda; otra liga que se abra sin sesion si. La marca se va
    al volver a entrar (`destinoDespuesDeEntrar`). */
export function marcarSalida(ruta) {
  const r = rutaValida(ruta);
  const s = almacen();
  if (!s) return;
  try {
    s.removeItem(LLAVE_HUBO_SESION);   // post-t7-2b (D7 a): cerrar sesion deja la pestana limpia
    if (r) s.setItem(LLAVE_RUTA_AL_SALIR, r);
    else s.removeItem(LLAVE_RUTA_AL_SALIR);
  } catch { /* nada */ }
}

/** Lee la ruta guardada SIN borrarla (valida, o null). */
export function rutaPendiente() {
  const s = almacen();
  if (!s) return null;
  try { return rutaValida(s.getItem(LLAVE_RUTA_PENDIENTE)); } catch { return null; }
}

export function borrarRutaPendiente() {
  const s = almacen();
  if (!s) return;
  try { s.removeItem(LLAVE_RUTA_PENDIENTE); } catch { /* nada */ }
}

/** A donde llega alguien que acaba de entrar: la ruta guardada valida o, si no hay, el Panel. Entrar quita la marca
    de la salida anterior. */
export function destinoDespuesDeEntrar() {
  const s = almacen();
  if (s) {
    try { s.removeItem(LLAVE_RUTA_AL_SALIR); } catch { /* nada */ }
  }
  return rutaPendiente() || '/dashboard';
}
